import React, {Component} from "react"
import 'datatables.net'
import 'datatables.net-bs'
import 'datatables.net-responsive'
import 'datatables.net-bs/css/dataTables.bootstrap.css'
import ReactDOM from "react-dom"
import Button from "../../../components/Button"
import {convertToDisplayFormat, formatDateInReport} from "../../../util/DateUtil"
import {injectIntl} from "react-intl"
import {
  COGO_TRAINING_NO_OF_CYCLES_PER_SESSION,
  COGOLAND_SESSION_DATE_FORMAT,
  convertSessionIndexToX
} from "../../../constants"
import CogoLandSessionStatusLabel from "./CogoLandSessionStatusLabel"
import SessionDateFrom from "./SessionDateFrom"
import {connect} from "react-redux"
import {rescheduleCogolandSession} from "../../../dispatch"

export const findActivityType = (sessions = [], type)=>{
  let result = false
  sessions.forEach(s=>{
    s.activities.forEach(a=>{
      if(a.type.name === type) result = true
    })
  })
  return result
}

function mapStateToProps(state, ownProps) {

  const user = state.user
  return {
    user
  }
}

const mapDispatchToProps = {
  rescheduleCogolandSession

}

const tableId = 'CogoLandSessionsTable'

const sessionsToData = (sessions) => {

  const dateTimeUnlockMap = {}
  sessions.forEach(session => {
    dateTimeUnlockMap[session.index] = session.dateTimeUnlock
  })

  return sessions.map((session) => {

    const quiz = !_.isNil(_.find(session.activities, (a) => {
      return _.startsWith(a.type.name, 'MCQ') || _.startsWith(a.type.name, 'PVT')
    }))


    return [
      convertSessionIndexToX(session.index),
      session.dateTimeUnlock,// convertToDisplayFormat(session.dateTimeUnlock, COGOLAND_SESSION_DATE_FORMAT),
      session.status,
      convertToDisplayFormat(session.dateTimeCompleted, COGOLAND_SESSION_DATE_FORMAT),
      quiz,
      session,
      [dateTimeUnlockMap[session.index - 1], dateTimeUnlockMap[session.index + 1]]
    ]
  })
}

const renderTable = (sessions, onSelect, format, intl, reschedule, onPage) => {

  const data = sessionsToData(sessions)

  $(`#${tableId}`).DataTable({
    data,
    responsive: true,
    dom: 'tp',
    ordering: false,
    pageLength: 24,
    "order": [[0, 'asc']],
    "columnDefs": [
      {
        "targets": 1,
        "data": null,
        "createdCell": function (td, data, rowData, row, col) {

          const sessionId = data[5].id
          const index = data[0]
          const status = data[2]
          const dateTimeUnlock = data[1]
          const dateFormatted = convertToDisplayFormat(dateTimeUnlock, COGOLAND_SESSION_DATE_FORMAT)

          const component = (
            <div>
              {status === 'NOT_STARTED' ?
                <SessionDateFrom
                  intl={intl}
                  id={index}
                  onChange={(date) => {
                    reschedule(sessionId, date)
                  }}
                  value={dateTimeUnlock} bounds={data[6]}/>
                :
                dateFormatted}
            </div>
          )
          ReactDOM.render(component, td)
        }
      },
      {
        "targets": 2,
        "data": null,
        "createdCell": function (td, data, rowData, row, col) {

          const status = data[2]

          const component = (
            <CogoLandSessionStatusLabel status={status} text={format({id:`cogoland.session.status.${status}`})}/>
          )
          ReactDOM.render(component, td)
        }
      },
      {
        "targets": 4,
        "data": null,
        "createdCell": function (td, data, rowData, row, col) {

          const quiz = data[4]?format({id:'yes'}):'-'

          const component = (
            <div>{quiz}</div>
          )
          ReactDOM.render(component, td)
        }
      },
      {
        "targets": 5,
        "data": null,
        "createdCell": function (td, data, rowData, row, col) {

          const session = data[5]
          const activities = session.activities || []

          const component = (
            session.status !== 'NOT_STARTED' ? (
              <div>
                <Button onClick={() => {
                  if (onSelect) onSelect(session)
                }}>
                  {format({id:'cogoland.button.view'})}
                </Button>
                {/*<ul>
                  {activities.map(it=><li>{it.id} {it.type.name} {Math.round(it.averageAttention)}</li>)}
                </ul>*/}
              </div>

            ) : <div/>
          )
          ReactDOM.render(component, td)
        }
      }
    ]
  });
  const table = $(`#${tableId}`).DataTable()
  $(`#${tableId}`).on('page.dt', (e, config)=>{
    if(onPage){
      onPage(table.page.info().page+1)
    }
  })
  $(`#${tableId}`).DataTable().page('last').draw('page')

}

const updateTable = (users) => {
  const data = sessionsToData(users)
  $(`#${tableId}`).DataTable().clear()
  $(`#${tableId}`).DataTable().rows.add(data).draw()
  $(`#${tableId}`).DataTable().page('last').draw('page')
}

class CogoLandSessionsTable extends Component {

  constructor() {
    super()
    this.state = {isPVT: false}
  }

  componentDidMount() {
    const intl = this.props.intl
    const rescheduleCogolandSession = this.props.rescheduleCogolandSession
    const format = intl.formatMessage
    renderTable(this.props.data, this.props.onSelect, format, intl, rescheduleCogolandSession, (page)=>this.setState({currentPage: page}))


    if(findActivityType(this.props.data, 'PVT')){
      this.setState({isPVT: true})
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.data !== this.props.data)
      updateTable(nextProps.data)

  }

  render() {
    const intl = this.props.intl
    const format = intl.formatMessage
    return (

      <div>
        <h4>{format({id:"cycle"})} {this.state.currentPage}</h4>
        <table width="100%" className="table table-striped table-bordered table-hover dataTables-example" id={tableId}>
          <thead>
          <tr>
            <th>{format({id: 'cogoland.session.index'})}</th>
            <th>{format({id: 'cogoland.session.scheduled.date'})}</th>
            <th>{format({id: 'cogoland.session.status'})}</th>
            <th>{format({id: 'cogoland.session.completed.date'})}</th>
            <th>{this.state.isPVT ? format({id: 'cogoland.session.speed.challenge'}) : format({id: 'cogoland.session.quiz'})}</th>
            <th>{format({id: 'cogoland.session.result'})}</th>
          </tr>
          </thead>
          <tbody>
          </tbody>
        </table>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CogoLandSessionsTable))



// WEBPACK FOOTER //
// ./src/routes/cogoland/component/CogoLandSessionsTable.js